var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bool)?_c('div',{staticClass:"logon flex flex-x flex-y"},[_vm._v("注册成功！")]):_c('div',{staticClass:"logon flex flex-x flex-y"},[_vm._v("正在跳转登录...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }